import { defineComponent as _defineComponent } from 'vue'
import { isPC } from '../../../utils/env';
import Dialog from '../Dialog/index.vue';
import Transfer from '../Transfer/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isRadio: {
    type: Boolean,
    default: false,
  },
  isNeedSearch: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  userList: {
    type: Array,
    default: () => ([]),
  },
  total: {
    type: Number,
    default: 0,
  },
},
  emits: ['complete', 'search', 'getMore'],
  setup(__props, { emit: emits }) {

const props = __props





const reset = () => {
  emits('complete', []);
};

const submit = (dataList: any) => {
  emits('complete', dataList);
};

const handleSearchUser = (userID: string) => {
  emits('search', userID);
};

const handleGetMore = () => {
  emits('getMore');
};

return { __sfc: true,emits, props, reset, submit, handleSearchUser, handleGetMore, isPC, Dialog, Transfer }
}

})